'use client'

import React from 'react'

import { GlobalSearchTrigger } from '@/components/search/GlobalSearchTrigger'

type Props = {
  className?: string
  placeholder?: string
}

/**
 * Busca do header. Agora abre o modal de busca global (command palette) em vez de
 * navegar direto — gatilho + atalhos (Ctrl/Cmd+K, "/"). Ver GlobalSearchTrigger.
 */
export function HeaderSearch({ className, placeholder }: Props) {
  return <GlobalSearchTrigger className={className} placeholder={placeholder} />
}
